var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"no-data-text":"Sem dados","headers":_vm.headers,"items":_vm.items,"footer-props":{
    'items-per-page-text': 'Linhas por página',
    'page-text': '{0}-{1} de {2}',
    'items-per-page-all-text': 'Todos',
  },"items-per-page":5},scopedSlots:_vm._u([{key:"item.dataCadastro",fn:function(ref){
  var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.functions.converterDateTimeStringEmLocaleDateTimeString(item.dataCadastro))+" ")]}},{key:"item.nomeStatus",fn:function(ref){
  var item = ref.item;
return [_c('v-chip',{staticClass:"v-chip-light-bg font-weight-semibold text-capitalize",class:((_vm.resolveStatisticsIconVariation(item.nomeCategoriaStatus).color) + "--text"),attrs:{"small":"","color":_vm.resolveStatisticsIconVariation(item.nomeCategoriaStatus).color}},[_vm._v(" "+_vm._s(item.nomeStatus)+" ")])]}},{key:"item.actions",fn:function(ref){
  var item = ref.item;
return [_c('v-btn',{staticClass:"ml-5",attrs:{"icon":"","color":"primary","to":{
        name: 'front-atendimento-gestor',
        params: { },
        query: { filaId: item.idFila, filaNome: item.nomeFila, activeTab: 2, ticketProtocolo: item.protocolo },
      },"target":"_blank"}},[_c('v-icon',[_vm._v(_vm._s(_vm.icons.mdiEyeOutline))])],1)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }